import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

export const FormElement = ({
    label,
    bottomText,
    children,
    fullWidth = false,
}: {
    fullWidth?: boolean;
    label?: string;
    bottomText?: string | JSX.Element;
    children: JSX.Element | JSX.Element[];
}) => {
    return (
        <Box mt={3} p={0.4} width={fullWidth ? 1 : 'auto'}>
            {label && <Typography component="span" variant="body1">{label}&nbsp;</Typography>}
            <Box alignItems="baseline" display="flex" m={0.5}>
                {children}
            </Box>
            {bottomText && <Typography color="textSecondary" variant="caption">{bottomText}</Typography> }
        </Box>
    );
};
